/* eslint-disable no-undef */

// MUI components such as Tabs and TextareaAutosize observe their own layout.
// Defer observer callbacks until the next animation frame so a callback cannot
// resize another observed element during the browser's current delivery cycle.
export default function installDeferredResizeObserver() {
  if (typeof window === 'undefined' || !window.ResizeObserver) return;
  if (window.ResizeObserver.__boxshallDeferred) return;

  const NativeResizeObserver = window.ResizeObserver;

  class DeferredResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      let frameId;
      super((entries, observer) => {
        window.cancelAnimationFrame(frameId);
        frameId = window.requestAnimationFrame(() => callback(entries, observer));
      });
      this.cancelScheduledCallback = () => window.cancelAnimationFrame(frameId);
    }

    disconnect() {
      this.cancelScheduledCallback();
      super.disconnect();
    }
  }

  DeferredResizeObserver.__boxshallDeferred = true;
  window.ResizeObserver = DeferredResizeObserver;
}
